import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  FormGroup,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import {
  postSubmitForm,
} from "../../../helpers/forms_helper";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import UpdateQuantityModal from "../../UpdateQuantityModal";
import { AvField, AvForm } from "availity-reactstrap-validation";

const AllItemRequests = (props) => {
  const store_id = localStorage.getItem("store_id")
  const Store = localStorage.getItem("store_name")
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const { SearchBar } = Search;

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllOrders()
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const loadAllOrders = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 31) {
      setAllOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setAllOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }
    preloader(true);
    let date_from = dateFrom,
      date_to = moment(dateFrom)
        .add(days_diff / 2, "days")
        .format("YYYY-MM-DD");

    //console.log(date_from, date_to);

    let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/get_all_requests_and_transfers";
    const response1 = await postSubmitForm(url, {
      // date_from: date_from,
      // date_to: date_to,
      // store_id: store_id
    });
    if (response1 && response1.status === 1) {
      const orderRequests = response1.data.orderRequests;
      const filteredRequests = orderRequests.filter(request => request.store_and_order_details.order_requested_to.name === Store);
      filteredRequests.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const updated = filteredRequests.map(order => {
        const newOrder = JSON.parse(JSON.stringify(order));

        newOrder.requested_items = newOrder.requested_items.map(item => {
          item.quantity = item.quantity.map((q, index) => ({
            ...q,
            index,
            isChecked: true
          }));
          return item;
        });

        return newOrder;
      });
      preloader(false)
      setAllOrders(updated);
    } else {
      preloader(false);
      showNotification(response1.message, "Error");
      return false;
    }
  };

  const [itemsForDispatch, setItemsForDispatch] = useState(false)
  const loadItemsForDelivery = async (requestId) => {
    let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/get_dispatch_details";
    const response = await postSubmitForm(url, { requestId:requestId });
    if (response && response.status === 1) {
      handleSetItemsForFullDelivery(response.data.to_deliver)
    } else {
      showNotification(response.message, "Error");
    }
  };
  const validateItemClosure = (item) => {
    const availableQty = convertToLowestUnit(item.unit_levels, item.store_available);
    const requstedQty = convertToLowestUnit(item.unit_levels, item.quantity || []);
    if (requstedQty > availableQty) {
      return {
        isValid: false,
        message: `Requested quantity for <strong>${ item.name }</strong > exceeds store available quantity.`
      };
  }

  return { isValid: true };
};
const handleSetItemsForFullDelivery = async (items) => {    
    let filtered = items.filter((data)=>data.is_dispatchable)
  if (filtered.length > 0) {
    let new_arr = filtered.map((prod) => {
      let obj = {
        item_id: prod.item_id,
        name: prod.name,
        category: prod.category,
        sub_category: prod.sub_category,
        ordered_quantity: prod.ordered_quantity.map(({unit,value})=>({unit,value})),
        quantity: prod.quantity.map(({unit,value})=>({unit,value})),
        store_available: prod.store_available,
        unit_levels:prod.unit_levels
      };
      return obj;
    });
    setItemsForDispatch(new_arr);
  } else {
    setItemsForDispatch([]);
  }
};
const [confirmApprove, setConfirmApprove] = useState(false);
const [confirmReject, setConfirmReject] = useState(false);
const [selectedOrder, setSelectedOrder] = useState();
const [isDisabled, setIsDisabled] = useState(false)

const handleApproveOrder = async () => {
  if (isDisabled) return;
  if (!itemsForDispatch || itemsForDispatch.length === 0) {
    showNotification("Nothing left to dispatch.", "Warning");
    return;
  }
  setIsDisabled(true);
  let isValid = true;
  let payload = {
    requestId: selectedOrder._id,
    status: "Accepted",
    editedItems: itemsForDispatch
  }
  for (const item of itemsForDispatch) {
    const validationResult = validateItemClosure(item);
    if (!validationResult.isValid) {
      isValid = false;
      setIsDisabled(false);
      showNotification(validationResult.message, "Warning");
      return
    }
  }
  if (isValid) {

    let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/update_and_dispatch_order";
    const response = await postSubmitForm(url, payload);

    if (response && response.status === 1) {
      loadAllOrders();
      setItemsForDispatch([]);
      setIsDisabled(false)
      setItemsModal(false)
    } else if (response.status === 2) {
      setIsDisabled(false)
      showNotification(response.message, "Warning");
    } else {
      setIsDisabled(false)
      showNotification(response.message, "Error");
    }
  }

};
const [CloseRemarks, setCloseRemarks] = useState();
const [closeModal, setCloseModal] = useState();
const handleRejectOrder = async (e, v) => {
  let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/update_and_dispatch_order";
  const response = await postSubmitForm(url, {
    requestId: selectedOrder._id,
    status: "Rejected",
    editedItems: selectedOrder.requested_items
  });
  //console.log(data_to_send);
  if (response && response.status === 1) {
    loadAllOrders();
    showNotification(response.message, "Success");
  } else if (response.status === 2) {
    showNotification(response.message, "Warning");
  } else {
    showNotification(response.message, "Error");
  }
};


const handleCloseOrder = async () => {
  let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/set_closed";
  const response = await postSubmitForm(url, {
    requestId: selectedOrder._id,
    remark: CloseRemarks,
  });

  if (response && response.status === 1) {
    setCloseRemarks("");
    loadAllOrders();
    setCloseModal(false);
    showNotification(response.message, "Success");
  } else {
    showNotification(response.message, "Error");
  }
};

const [itemsModal, setItemsModal] = useState();
const [confirmClose, setConfirmClose] = useState(false);

const columns_external = [
  {
    dataField: "_id",
    hidden: true,
  },
  {
    dataField: "_id",
    formatter: (cell, row, rowIndex) => {
      return rowIndex + 1;
    },
    text: props.t("#"),
    headerStyle: (colum, colIndex) => {
      return { width: "2%" };
    },
  },
  {
    text: props.t("Order Id"),
    dataField: "order_id",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "7%" };
    },
  },
  {
    text: props.t("Order From"),
    dataField: "store_and_order_details.order_requested_from.name",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "10%" };
    },
  },
  {
    text: props.t("Order To"),
    dataField: "store_and_order_details.order_requested_to.name",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "10%" };
    },
  },
  {
    dataField: "CreateDate",
    text: props.t("Date"),
    formatter: (cell, row) =>
      moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
  },
  {
    dataField: "status",
    text: props.t("Status"),
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
  
  },
  {
    dataField: "remark",
    text: props.t("Remarks"),
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
  
  },
  {
    text: props.t("Details"),
    formatter: (cell, row) => {
      return (
        <span className="text-info d-flex justify-content-center">
          <i
            className="mdi mdi-text-box-search"
            title="View Details"
            style={{ cursor: "pointer" ,fontSize:"20px"}}
            onClick={() => {
              setSelectedOrder(prev=>prev=row)
              setItemsForDispatch([])
              setItemsModal(!itemsModal);
            }}
          ></i>
        </span>
      );
    },
    csvExport: false,
    sort: false,
    headerStyle: (colum, colIndex) => {
      return { width: "5%" };
    },
  },
  {
    dataField: "",
    text: props.t("Action"),
    sort: false,
    formatter: (cell, row) => {
      if (row.status === "Pending") {
        return (
          <>
            <button
              class="btn btn-info btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setItemsForDispatch([]);
                loadItemsForDelivery(row._id);
                setItemsModal(true);
                // setConfirmApprove(true);
              }}
            >
              {props.t("Dispatch")}
            </button>
            <button
              class="btn btn-danger btn-sm mr-2"
              onClick={() => {
                // setCloseModal(!closeModal);
                setConfirmReject(true)
                setSelectedOrder(row);
              }}
            >
              {props.t("Reject")}
            </button>
            {/* <button
                  class="btn btn-success btn-sm mr-2"
                  onClick={() => {
                    setSelectedPO(row);
                  setPOItems(row.requested_items);
                  setItemsModal(!itemsModal);
                  }}
                >
                  {props.t("Edit")}
                </button> */}
          </>
        );
      }else if(row.status !== "Pending" &&  row.status !== "Closed" && row.status !== "Rejected" && row.status !== "Fully Dispatched") {
       return( 
       <>
            <button
              class="btn btn-info btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setItemsForDispatch([]);
                loadItemsForDelivery(row._id);
                setItemsModal(true);
              }}
            >
              {props.t("Dispatch")}
            </button>
            <button
              class="btn btn-primary btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setCloseModal(true)
              }}
            >
              {props.t("Close")}
            </button>
        </>
          )
      }
      else {
        return "No Action Required"
      }
    },
    headerStyle: (colum, colIndex) => {
      return { width: "10%" };
    },
  },
];
const columns_items_to_dispatch = [
  {
    dataField: "item_id",
    hidden: true,
  },
  {
    text: props.t("Item"),
    dataField: "name",
    editable: false,
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "18%" };
    },
  },
  {
    text: props.t("Category"),
    dataField: "category",
    editable: false,
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
  },
  {
    text: props.t("Sub Category"),
    dataField: "sub_category",
    editable: false,
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
  },
  {
    dataField: "quantity",
    text: props.t("Order Qty."),
    editable: false,
    formatter: (cell, row) => {
     return  formatUnitsForReport(row.ordered_quantity,row.unit_levels)
    },
    sort: false,
    headerStyle: (colum, colIndex) => {
      return { width: "15%" };
    },
  },
  {
    dataField: "quantity",
    editable: false,
    formatter: (cell, row) => {
      return (
        <div className="d-flex align-items-center justify-content-between">
            <span className="me">
             {formatUnitsForReport(row.quantity)}
            </span>

              <Button
                className="btn btn-success btn-sm"
                onClick={() => {
                  const updatedItem = {
                    ...row,
                    quantity: row.quantity.map((item, idx) => ({
                      ...item,
                      index: idx,
                      isChecked: true,
                    })),
                  };
                  setSelectedItems(updatedItem)
                  setEditUnitModal(true);
                }}
              >
                {props.t("Edit")}
              </Button>
        </div>
      )
    },
    text: props.t("Deliver Quantity"),
    sort: false,
    editable: false,
    style: (cell, row, rowIndex, colIndex) => {
      return { cursor: "pointer", background: "#ffffaa" };
    },
    headerStyle: (colum, colIndex) => {
      return { width: "15%" };
    },
  },
  {
    dataField: "store_available",
    text: props.t("Central Avl. Qty."),
    editable: false,
    formatter: (cell, row) => {
     return  formatUnitsForReport(row.store_available,row.unit_levels)
    },
    sort: false,
    headerStyle: (colum, colIndex) => {
      return { width: "15%" };
    },
  },
];
const [selectedItems, setSelectedItems] = useState([]);
const [editUnitModal, setEditUnitModal] = useState(false)

const columns_items = [
  {
    dataField: "item_id",
    hidden: true,
  },
  {
    dataField: "name",
    text: props.t("Name"),
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  {
    text: props.t("Category"),
    dataField: "category",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "7%" };
    },
    editable: false,
  },
  {
    dataField: "sub_category",
    text: props.t("Sub-Category"),
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  {
    dataField: "available",
    text: props.t("Available"),
    formatter: (cell, row) => {
      return formatUnitsForReport(row.available,row.unit_levels)
    },
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  {
    dataField: "quantity",
    text: props.t("Order Quantity"),
    formatter: (cell, row) => {
      return (formatUnitsForReport(row.quantity))
    },
    headerStyle: (colum, colIndex) => {
      return { width: "10%" };
    },
    editable: false,
  },
  {
    dataField: "store_available",
    text: props.t("Store Available"),
    formatter: (cell, row) => {
      return formatUnitsForReport(row.store_available,row.unit_levels)
    },
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  // {
  //   dataField: "receive",
  //   text: props.t("To Receive"),
  //   editable: false,
  //   formatter: ReceiveFormatter,
  //   headerStyle: (colum, colIndex) => {
  //     return { width: "12%" };
  //   },
  //   style: (cell, row, rowIndex, colIndex) => {
  //     return { cursor: "pointer", background: "#ffffaa" };
  //   }
  // },
];
const handleOnExpand = (row, isExpand, rowIndex, e) => {
  if (isExpand) {
    setExpanded([...expanded, row._id]);
  } else {
    setExpanded(expanded.filter((x) => x !== row._id));
  }
};
const [expanded, setExpanded] = useState([]);
const expandRow = {
  onlyOneExpanding: true,
  renderer: (row) => (
    <div>
      <BootstrapTable
        bootstrap4
        keyField="_id"
        data={row.requested_items}
        columns={columns_items}
        noDataIndication="No data to display."
        striped
        hover
        condensed
      />
    </div>
  ),
  expanded: expanded,
  onExpand: handleOnExpand,
};
const handleDownload = async () => {
  const fileName = "all_request";
  const exportType = "xls";
  let data_to_export = allOrders;
  if (data_to_export) {
    var data = [];
    JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
      data.push({
        order_id: v.order_id,
        Order_From: v.store_and_order_details.order_requested_from.name,
        Order_To: v.store_and_order_details.order_requested_to.name,
        Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
        status: v.status,
      });
    });

    exportFromJSON({ data, fileName, exportType });
  }
};

const handleUpdateUnit = (quantity) => {
  let convertedQuantity = GetUpdatedDelivered(quantity, selectedItems?.unit_levels)
  const updatedItems = itemsForDispatch.map(prod => {
    if (prod.item_id === selectedItems.item_id) {
      return {...selectedItems, quantity:convertedQuantity.map(({unit,value})=>({unit,value:+value}))};
    }
    return prod;
  });
  setSelectedItems()
  setItemsForDispatch(updatedItems)
};

const columns_delivered_items = [
  {
    dataField: "item_id",
    hidden: true,
  },
  {
    dataField: "name",
    text: props.t("Name"),
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  {
    text: props.t("Category"),
    dataField: "category",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "7%" };
    },
    editable: false,
  },
  {
    dataField: "sub_category",
    text: props.t("Sub-Category"),
    headerStyle: (colum, colIndex) => {
      return { width: "8%" };
    },
    editable: false,
  },
  {
    text: props.t("Batch"),
    dataField: "batch",
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "10%" };
    },
    editable: false,
    formatter: (cell) => {
      return cell || "-";
    },
  },
  {
    dataField: "delivered_quantity",
    text: props.t("Delivered Qty."),
    formatter: (cell, row) => {
     return formatUnitsForReport(row.delivered_quantity,row.unit_levels)
    },
    sort: true,
    headerStyle: (colum, colIndex) => {
      return { width: "12%" };
    },
  },
  {
    dataField: "quantity",
    text: props.t("Received Qty."),
    editable: false,
    formatter: (cell, row) => {
      return formatUnitsForReport(row.receiving_quantity,row.unit_levels)
    },
    headerStyle: (colum, colIndex) => {
      return { width: "12%" };
    },
  },
  {
    text: props.t("Received ?"),
    dataField: "is_received",
    formatter: (cell, row) => {
      return row.is_received ? "Yes" : "No";
    },
    headerStyle: (colum, colIndex) => {
      return { width: "5%" };
    },
  },
  {
    text: props.t("Remarks"),
    dataField: "remarks",
    headerStyle: (colum, colIndex) => {
      return { width: "5%" };
    },
  }
];
const rowStyle = (row, rowIndex) => {
  const style = { backgroundColor: "", fontWeight: "500" };
   if (row.status === "Pending") {
      style.backgroundColor = "#ffb8b8";
  } else if (row.status === "Rejected") {
      style.backgroundColor = "#f1b8ff";
  } else if (row.status === "Partially Dispatched") {
      style.backgroundColor = "#b8cdff";
  } else if (row.status === "Fully Dispatched") {
      style.backgroundColor = "#b8ffdf";
  } else if (row.status === "Fully Received") {
      style.backgroundColor = "#b8f3ff";
  }else if (row.status === "Closed") {
    style.backgroundColor = "#fffbb8";
}

  return style;
};
// console.log(selectedOrder,"so");

return (
  <React.Fragment>

    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col sm="4">
                <Button
                  type="submit"
                  className="btn btn-sm btn-secondary"
                  onClick={handleDownload}
                >
                  <i className="mdi mdi-file-export"></i>{" "}
                  {props.t("Export CSV")}
                </Button>
                {"   "}
                <Link
                  to="#"
                  onClick={() => {
                    printDiv("printDiv");
                  }}
                  className="btn btn-sm btn-success mr-2"
                >
                  <i className="fa fa-print"></i> Print
                </Link>
                <div className="search-box mr-2 mb-2 d-inline-block">
                  <div className="position-relative"></div>
                </div>
              </Col>
            </Row>
            <div id="printDiv">
              <ToolkitProvider
                bootstrap4
                keyField="_id"
                data={allOrders && allOrders || []}
                columns={columns_external}
                noDataIndication={props.t("No data to display.")}
                search
              >
                {(props) => (
                  <div>
                    <Row>
                      <Col lg={4}>
                        <SearchBar
                          {...props.searchProps}
                          style={{ width: "300px" }}
                        />
                      </Col>
                      <Col lg={4}>
                        {" "}
                        <CardTitle>All Orders </CardTitle>
                      </Col>
                      <Col lg={4} className="text-right">

                      </Col>
                    </Row>
                    <BootstrapTable
                      striped
                      filter={filterFactory()}
                      hover
                      condensed
                      expandRow={expandRow}
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
              {confirmApprove && (
                <SweetAlert
                  title={props.t("Are you sure?")}
                  warning
                  showCancel
                  cancelBtnText={props.t("No")}
                  confirmBtnText={props.t("Yes")}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => {
                    setConfirmApprove(false);
                    handleApproveOrder();
                  }}
                  onCancel={() => {
                    setConfirmApprove(false);
                  }}
                >
                  {props.t(
                    "Once you accept this order, it cannot be revoked."
                  )}
                </SweetAlert>
              )}


              {confirmReject && (
                <SweetAlert
                  title={props.t("Are you sure?")}
                  warning
                  showCancel
                  cancelBtnText={props.t("No")}
                  confirmBtnText={props.t("Yes")}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => {
                    setConfirmReject(false);
                    handleRejectOrder();
                  }}
                  onCancel={() => {
                    setConfirmReject(false);
                  }}
                >
                  {props.t(
                    "Once you reject this order, it cannot be revoked."
                  )}
                </SweetAlert>
              )}
            </div>
            {/* Item modal */}
            <Modal
              // size="lg"
              style={{
                width: "1100px",
                maxWidth: "1100px",
              }}
              isOpen={itemsModal}
              toggle={() => {setItemsModal(!itemsModal);setSelectedOrder()}}
            >
              <ModalHeader toggle={() => {setItemsModal(!itemsModal);setSelectedOrder()}}>
                Order ID: {selectedOrder && selectedOrder.order_id}
              </ModalHeader>
              <ModalBody>
                {selectedOrder && (
                  <>
                    <Row>
                      <Col lg={12}>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col lg={12}>
                                <Label>{props.t("Ordered Items")}</Label>
                                <ToolkitProvider
                                  keyField="_id"
                                  data={selectedOrder?.requested_items}
                                  columns={columns_items}
                                >
                                  {(props) => (
                                    <div>
                                      <BootstrapTable
                                        {...props.baseProps}
                                        cellEdit={cellEditFactory({
                                          mode: "click",
                                          blurToSave: true,
                                        })}
                                        noDataIndication="No data to display."
                                        striped
                                        hover
                                        condensed
                                      />
                                    </div>
                                  )}
                                </ToolkitProvider>
                              </Col>
                              {selectedOrder.received_items.length>0 &&(
                                   
                                   <Col lg={12}>
                                     <Label>Dispatched Items</Label>
                                     <ToolkitProvider
                                       keyField="_id"
                                       data={selectedOrder && selectedOrder.received_items}
                                       columns={columns_delivered_items}
                                     >
                                       {(props) => (
                                         <div>
                                           <BootstrapTable
                                             {...props.baseProps}
                                            //  cellEdit={cellEditFactory({
                                            //    mode: "click",
                                            //    blurToSave: true,
                                            //  })}
                                             noDataIndication="No data to display."
                                             striped
                                             hover
                                             condensed
                                           />
                                         </div>
                                       )}
                                     </ToolkitProvider>
                                   </Col>
                                
                               )}

{itemsForDispatch && itemsForDispatch.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>
                                            {props.t("Items to Deliver")}
                                          </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={
                                            itemsForDispatch &&
                                            itemsForDispatch
                                          }
                                          cellEdit={cellEditFactory({
                                            mode: "click",
                                            blurToSave: true,
                                           
                                          })}
                                          columns={columns_items_to_dispatch}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                      </Col>
                                    </>
                                  ) : null}
                                  {itemsForDispatch.length>0 && (
                                    <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            onClick={handleApproveOrder}
                                            color="primary"
                                            className="mr-1"
                                            style={{width:"100px"}}
                                            disabled={isDisabled}
                                          >
                                             {isDisabled ? <Spinner size="sm" /> : props.t("Dispatch")} 
                                          </Button>
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  )}
                            </Row>

                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </>
                )}
              </ModalBody>
            </Modal>

             {/* ---Close Reamarks Modal Start--- */}
             {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleCloseOrder();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you close this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}
                  <Modal
                    size="md"
                    isOpen={closeModal}
                    toggle={() => setCloseModal(!closeModal)}
                  >
                    <ModalHeader toggle={() => setCloseModal(!closeModal)}>
                      Order ID: {selectedOrder && selectedOrder.order_id}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <AvForm
                                  onValidSubmit={(e, v) =>
                                    setConfirmClose(true)
                                  }
                                >
                                  <Row>
                                    <Col lg={12}>
                                      <AvField
                                        name="admin_remarks"
                                        placeholder="Enter remarks"
                                        type="textarea"
                                        onChange={(e) =>
                                          setCloseRemarks(e.target.value)
                                        }
                                        value={CloseRemarks}
                                        label="Remarks"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "Remarks cannot be empty.",
                                          },
                                        }}
                                      />
                                    </Col>

                                    <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="mr-1"
                                          >
                                            {props.t("Submit")}
                                          </Button>
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </AvForm>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                  {/* ---Close Reamarks Modal End--- */}

            {/* Edit Units Modal  */}
            <UpdateQuantityModal
              isOpen={editUnitModal}
              toggle={() => setEditUnitModal(false)}
              onSubmit={handleUpdateUnit}
              item={selectedItems}
            />


          </CardBody>
        </Card>
      </Col>
    </Row>
  </React.Fragment>
);
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AllItemRequests))
);